import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Link from 'components/Link/Link';
import { TOI_IMAGE_DOMAIN } from '../../constants';
import s from './MiniTv.scss';

const MiniTvSS = ({ miniTvData, minitvMwebInPage, styleObject, layout }) => {
  const renderMobileMiniTvPlayerWithBanner = () => {
    if (!miniTvData) {
      return null;
    }
    const expandedBox = false;
    const { w, sSwrapper } = layout || {};
    const styleObj = styleObject || s;
    const mainContainer = `${styleObj.minitv} ${s.collapsedMinitv}`;
    let minitvView = '';
    if (minitvMwebInPage) {
      minitvView = s.largeview;
    }
    const containerClasses = classNames({
      [mainContainer]: !expandedBox,
      [s[sSwrapper]]: sSwrapper,
      [minitvView]: minitvView,
    });
    const { shareUrl, bottomCta = {} } = miniTvData;
    const bottomCtaConfig = {
      active: bottomCta.forAll || minitvMwebInPage,
      url: bottomCta.url || shareUrl,
      text: bottomCta.text || 'Watch',
      target: bottomCta.target || '_blank',
    };

    const msid = miniTvData.imageid;
    let src;
    if (msid)
      src = `${TOI_IMAGE_DOMAIN}/thumb/msid-${msid},width-${w},resizemode-4/${msid}.jpg`;
    const isDescEnabled = miniTvData.marker || miniTvData.hl;
    const descWrapper = classNames({
      [s.bottomTxt]: isDescEnabled,
    });
    return (
      <>
        <Link target="_blank" to={shareUrl} forceTargetBlank>
          <div className={containerClasses}>
            <div
              className={`${s.minitvInnerContainer} ${
                styleObj.minitvInnerContainer
              }`}
            >
              <div className={`${s.minitv_txt}`}>
                <div className={s.promowrapper}>
                  <div className={`${s.player_container} `}>
                    <div className={s.loader}>
                      <span />
                    </div>
                    {src && (
                      <img
                        className={`${s.banner_image} globalBannerImage`}
                        src={src}
                        alt="logo"
                      />
                    )}
                  </div>
                </div>
                <div className={descWrapper}>
                  {miniTvData?.marker && (
                    <h2 className={`${s.blinker}`}>{miniTvData?.marker}</h2>
                  )}
                  {miniTvData?.hl && (
                    <h3
                      className={
                        miniTvData?.sponsorshipby
                          ? ''
                          : `${s.lineClamp} globalMinitvDesc`
                      }
                    >
                      {miniTvData?.hl}
                    </h3>
                  )}
                  {bottomCtaConfig.active && (
                    <span className={s.watchBtn}>
                      {bottomCtaConfig.text}
                      <i />
                    </span>
                  )}
                </div>
              </div>
            </div>
          </div>
        </Link>
      </>
    );
  };

  return renderMobileMiniTvPlayerWithBanner();
};

MiniTvSS.propTypes = {
  miniTvData: PropTypes.shape({}).isRequired,
};
MiniTvSS.defaultProps = {};
export default MiniTvSS;
